<template>
  <div id="calculator" :class="wrapperClass">
    <iframe
      :id="type"
      class="VisiCalcClass"
      :class="iframeClass"
      :src="src"
      :frameborder="frameBorder"
      :scrolling="scroll"
    />
  </div>
</template>
<script setup>
defineOptions({
  name: 'AtomsCalculatorFrame'
})

defineProps({
  type: {
    type: String,
    required: true
  },
  src: {
    type: String,
    required: true
  },
  title: {
    type: String,
    default: ''
  },
  scroll: {
    type: String,
    default: 'no'
  },
  iframeClass: {
    type: String,
    default: ''
  },
  frameBorder: {
    type: String,
    default: '0'
  },
  wrapperClass: {
    type: String,
    default: 'mb-4'
  }
})
</script>
<style scoped>
/* calculator styles */
.VisiCalcClass {
  /* background: url(/staticAssets/calculators/load.gif) 50% 15% no-repeat; */
  background-size: 80px 80px;
  min-width: 750px;
  min-height: 800px;
  margin: 0;
  padding: 0;
}

#Loan_Repayment_Calculator {
  min-height: 750px !important;
}

#Borrowing_Power_Calculator {
  min-height: 750px !important;
}

#Budget_Planner {
  min-height: 850px !important;
}

#Compound_Interest_Calculator {
  min-height: 850px !important;
}

#Credit_Card_Calculator {
  min-height: 900px !important;
}

#How_Long_to_Repay_Calculator {
  min-height: 750px !important;
}

#Interest_Only_Mortgage_Calculator {
  min-height: 750px !important;
}

#Saving_Calculator {
  min-height: 600px !important;
}

#Split_Loan_Calculator {
  min-height: 800px !important;
}

#Property_Selling_Cost_Calculator {
  min-height: 620px !important;
}

#Reverse_Mortgage_Calculator {
  min-height: 1100px !important;
}

#Stamp_Duty_Calculator {
  min-height: 730px !important;
}

#Income_Gross_Up_Calculator {
  min-height: 900px !important;
}

#Income_Gross_Up_Calculator {
  min-height: 900px !important;
}

#RentvsBuyCalculator {
  min-height: 1100px !important;
}

#Mortgage_Switching_Calculator {
  min-height: 950px !important;
}

#How_Much_to_Deposit_Calculator {
  min-height: 600px !important;
}

#Property_Buying_Cost_Calculator {
  min-height: 710px !important;
}

@media screen and (max-width: 767px) {
  .VisiCalcClass {
    min-width: 100%;
    min-height: 1250px;
    margin: 0;
    padding: 0;
  }

  #Loan_Repayment_Calculator {
    min-height: 1250px !important;
  }

  #Borrowing_Power_Calculator {
    min-height: 780px !important;
  }

  #Budget_Planner {
    min-height: 1050px !important;
  }

  #Comparison_Rate_Calculator {
    min-height: 1450px !important;
  }

  #Compound_Interest_Calculator {
    min-height: 1200px !important;
  }

  #Credit_Card_Calculator {
    min-height: 1500px !important;
  }

  #Extra_Repayment_Calculator {
    min-height: 1450px !important;
  }

  #Home_Loan_Offset_Calculator {
    min-height: 1400px !important;
  }

  #How_Long_to_Repay_Calculator {
    min-height: 1250px !important;
  }

  #Interest_Only_Mortgage_Calculator {
    min-height: 1450px !important;
  }

  #Saving_Calculator {
    min-height: 1250px !important;
  }

  #Introductory_Rate_Loan_Calculator {
    min-height: 1400px !important;
  }

  #Lump_Sum_Repayment_Calculator {
    min-height: 1450px !important;
  }

  #Split_Loan_Calculator {
    min-height: 1550px !important;
  }

  #Loan_Comparison_Calculator {
    min-height: 1800px !important;
  }

  #Property_Buying_Cost_Calculator {
    min-height: 800px !important;
  }

  #Property_Selling_Cost_Calculator {
    min-height: 620px !important;
  }

  #Reverse_Mortgage_Calculator {
    min-height: 1900px !important;
  }

  #Stamp_Duty_Calculator {
    min-height: 750px !important;
  }

  #Income_Gross_Up_Calculator {
    min-height: 1700px !important;
  }

  #Income_Gross_Up_Calculator {
    min-height: 1700px !important;
  }

  #RentvsBuyCalculator {
    min-height: 1900px !important;
  }

  #Mortgage_Switching_Calculator {
    min-height: 980px !important;
  }

  #How_Much_to_Deposit_Calculator {
    min-height: 650px !important;
  }
}

@media screen and (max-width: 425px) {
  #Borrowing_Power_Calculator {
    min-height: 1640px !important;
  }
}

@media screen and (min-width: 320px) and (max-width: 530px) {
  #Mortgage_Switching_Calculator {
    min-height: 1800px !important;
  }

  #Property_Selling_Cost_Calculator {
    min-height: 1200px !important;
  }

  #Property_Buying_Cost_Calculator {
    min-height: 1810px !important;
  }

  #How_Much_to_Deposit_Calculator {
    min-height: 1200px !important;
  }

  #Stamp_Duty_Calculator {
    min-height: 1210px !important;
  }
}
</style>